var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/native-promise-constructor.js
// module id = 217
// module chunks = 0